// finding D-05 (extended): Shell's sidebar/mobile nav and its Logout button
// live outside WritersRoomProvider's tree, so they can't read `pendingChanges`
// directly. react-router's useBlocker (the "real" fix) needs a data router,
// which this app doesn't use — see useWritersRoomState.js for that trade-off.
// This plain module-level flag is the lightest way to extend the same
// confirm() guard to those exit paths: useWritersRoomState writes it whenever
// pendingChanges changes, Shell reads it before navigating.
let hasPendingChanges = false;

export function setHasPendingWritersRoomChanges(value) {
    hasPendingChanges = value;
}

export function confirmDiscardPendingWritersRoomChanges(
    message = 'You have unsaved changes in the Writers Room that will be lost if you leave. Continue?'
) {
    if (!hasPendingChanges) return true;
    return window.confirm(message);
}
